import useMediaQuery from '@app/util/useMediaQuery'
import { TopNavBar as MobileNavBar } from './TopNavBar.mobile'
import { TopNavBar as DesktopNavBar } from './TopNavBar.desktop'
import { memo } from 'react'
import { fullName } from '@app/util/helpers'
import { useUserContext } from '@app/util/hooks/useUserContext'

const TopNavBar = () => {
  const isMobile = useMediaQuery()
  const { user, isLoading } = useUserContext()

  const userName = user ? fullName(user) : undefined

  return isMobile ? (
    <MobileNavBar
      userName={userName}
      avatar={user?.avatar?.src}
      isLoading={isLoading}
    />
  ) : (
    <DesktopNavBar
      userName={userName}
      avatar={user?.avatar?.src}
      isLoading={isLoading}
    />
  )
}

export default memo(TopNavBar)
